import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDsoGroupList } from '../../../../../../../actions/dsosActions';
import { createLoadingSelector } from '../../../../../../../apis/selectors';

const actions = ['FETCH_DSO_GROUP_LIST'];
const loadingSelector = createLoadingSelector(actions);

export const useDsoGroupList = (dsoId) => {
  const dispatch = useDispatch();
  const { filters, data, total, isActiveRequest, isFinalPage, dsoId: stateDsoId } = useSelector(
    (state) => state.dsos.dsoGroupList,
  );
  const totalPages = Math.ceil(total / filters.limit);
  const isLoading = useSelector((state) => loadingSelector(state));

  const handleScrollList = useCallback(
    (event) => {
      const tableScrollHeight = event?.target?.scrollHeight - event?.target?.scrollTop - 20;
      const clientHeight = event?.target?.clientHeight;
      if (tableScrollHeight <= clientHeight && !isActiveRequest && !isFinalPage) {
        dispatch(fetchDsoGroupList(dsoId, { page: filters.page + 1 }));
      }
    },
    [dispatch, filters.page, isActiveRequest, isFinalPage, dsoId],
  );

  useEffect(() => {
    dispatch(fetchDsoGroupList(dsoId));
  }, [dispatch, dsoId]);

  return {
    data: stateDsoId === dsoId ? data : [],
    total,
    totalPages,
    limit: filters.limit,
    isInitialLoading: !data.length && isLoading,
    isLoading: isActiveRequest,
    handleScrollList,
  };
};
